import { Skeleton } from "@mantine/core";

/**
 * Skeleton for the payment methods list in StepTwo.
 */
export default function PaymentMethodsSkeleton() {
  return (
    <div className="p-5 flex flex-col gap-4 bg-white border-t border-gray-200">
      <Skeleton height={20} width="50%" radius="sm" />
      {[1, 2, 3].map((i) => (
        <div
          key={i}
          className="flex items-center gap-4 border-2 border-gray-200 rounded-xl p-4"
        >
          <Skeleton height={36} width={36} circle />
          <div className="flex flex-col gap-2 flex-1">
            <Skeleton height={16} width="40%" radius="sm" />
            <Skeleton height={12} width="25%" radius="sm" />
          </div>
          <Skeleton height={20} width={20} circle />
        </div>
      ))}
    </div>
  );
}
